import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated } from "@azure/msal-react";
import Topbar from "../global/Topbar";
import AppSidebar from "../global/AppSidebar";
import { AppContext } from "../../components/AppContext";
import API from "../../Api";

const SecuredShell = () => {
  const [isSidebar, setIsSidebar] = useState(true);
  const [userInfo, setUserInfo] = useState({});
  const [appConfig, setAppConfig] = useState({});
  const [/*isContextLoading*/, setContextLoading] = useState(false);
  const isAuth = useIsAuthenticated();

  useEffect(() => {
    const getConfigInfo = async () => {
      setContextLoading(true);
      try {
        const r = await API.get(`/userinfo`);
        console.log("Update user info", r.data);
        setUserInfo(r.data);
      } catch (error) {
      }
      try {
        const r1 = await API.get(`/config/RTS`);
        console.log("Update app config", r1.data);
        setAppConfig(r1.data);
      } catch (error) {
      }
      setContextLoading(false);
    };

    if (isAuth) {
      console.log("Authenticated, so get config");
      getConfigInfo();
    }
    else {
      console.log("Unauthenticated, so clear config");
      setUserInfo({});
      setAppConfig({});
    }
  }, [isAuth]);

  return (
    <>
      <AuthenticatedTemplate>
        <AppContext userInfo={userInfo} appConfig={appConfig}>
          <div className="app">
            <AppSidebar isSidebar={isSidebar} />
            <main className="content">
              <Topbar setIsSidebar={setIsSidebar} />
              <Outlet />
            </main>
          </div>
        </AppContext>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Navigate to={{ pathname: "/login" }} />
      </UnauthenticatedTemplate>
    </>
  );
};

export default SecuredShell;
